"use strict";


const termSet = {

};

export function defineSimpleTerm( term, def=null, locs={} )  {
  const blk = (termSet[term] = (termSet[term]||{}));
  Object.assign(blk, locs||{}, { ["*"] : def });
}


export function _I_( term )  {
  const blk = (termSet[term]||{});

  const l = blk[SettingsInjections.getUsedLocale().code]||blk["*"];
  return (l == null) ? `<<${term}>>`: l;
}

